import Utils from '@/ecm/common/Utils';
export default class DigitalSignature {
    constructor (dto) {
        this.id = 0;
        this.name = '';
        this.digitalSignatureProviderId = 0;
        this.login = '';
        this.password = '';
        this.clientId = '';
        this.clientSecret = '';
        this.userId = '';
        this.profile = '';
        this.pinNumber = '';

        this.signatureVisible = false;
        this.signatureLocationX = 0;
        this.signatureLocationY = 0;
        this.signatureLocationPage = 1;
        this.signatureSizeX = 0;
        this.signatureSizeY = 0;
        this.signatureIncludeFrame = false;
        this.lastPageSignature = false;
        this.dateShifted = false;

        this.signatureIncludeDescription = false;
        this.signatureIncludeUserFullName = false;
        this.signatureIncludeTimeStamp = false;

        this.signatureIncludeImage = false;
        this.useUserSignatureImage = false;

        this.signatureIncludeCertificate = false;
        this.useUserCertificate = false;
        this.selectedSignatureId = null;

        this.signatureImage = null;
        this.signatureCertificateFileName = '';
        this.signatureCertificateBase64 = '';
        this.signatureImagePath = '';

        this.isKeyEncrypted = false;

        if (dto) {
            this.id = dto.Id;
            this.name = dto.Name;
            this.digitalSignatureProviderId = dto.DigitalSignatureProviderID;
            this.login = dto.Login;
            this.password = dto.Password;
            this.clientId = dto.ClientID;
            this.clientSecret = dto.ClientSecret;
            this.userId = dto.UserId;
            this.profile = dto.Profile;
            this.pinNumber = dto.PinNumber;

            this.signatureVisible = dto.SignatureVisible;
            this.signatureLocationX = dto.SignatureLocationX;
            this.signatureLocationY = dto.SignatureLocationY;
            this.signatureLocationPage = dto.SignatureLocationPage;
            this.lastPageSignature = dto.LastPageSignature;
            this.dateShifted = dto.DateShifted;
            this.signatureSizeX = dto.SignatureSizeX;
            this.signatureSizeY = dto.SignatureSizeY;
            this.signatureIncludeFrame = dto.SignatureIncludeFrame;

            this.signatureIncludeDescription = dto.SignatureIncludeDescription;
            this.signatureIncludeUserFullName = dto.SignatureIncludeUserFullName;
            this.signatureIncludeTimeStamp = dto.SignatureIncludeTimeStamp;

            this.signatureIncludeImage = dto.SignatureIncludeImage;
            this.useUserSignatureImage = dto.UseUserSignatureImage;
            this.selectedSignatureId = dto.SelectedSignatureId;
            this.signatureImagePath = dto.SignatureImagePath;

            this.signatureIncludeCertificate = dto.SignatureIncludeCertificate;
            this.useUserCertificate = dto.UseUserCertificate;

            this.signatureCertificateFileName = dto.SignatureCertificatePath;

            this.isKeyEncrypted = dto.IsKeyEncrypted;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            DigitalSignatureProviderID: parseInt(this.digitalSignatureProviderId),
            Login: this.login,
            Password: this.password,
            ClientID: this.clientId,
            ClientSecret: this.clientSecret,
            UserId: this.userId,
            Profile: this.profile,
            PinNumber: this.pinNumber,

            SignatureVisible: this.signatureVisible,
            SignatureLocationX: this.signatureLocationX,
            SignatureLocationY: this.signatureLocationY,
            signatureLocationPage: this.signatureLocationPage,
            LastPageSignature: this.lastPageSignature,
            DateShifted: this.dateShifted,
            SignatureSizeX: this.signatureSizeX,
            SignatureSizeY: this.signatureSizeY,
            SignatureIncludeFrame: this.signatureIncludeFrame,

            SignatureIncludeDescription: this.signatureIncludeDescription,
            SignatureIncludeUserFullName: this.signatureIncludeUserFullName,
            SignatureIncludeTimeStamp: this.signatureIncludeTimeStamp,

            SignatureIncludeImage: this.signatureIncludeImage,
            UseUserSignatureImage: this.useUserSignatureImage,
            SelectedSignatureId: this.selectedSignatureId,
            SignatureImagePath: this.signatureImagePath,
            SignatureCertificatePath: this.signatureCertificateFileName,

            SignatureIncludeCertificate: this.signatureIncludeCertificate,
            UseUserCertificate: this.useUserCertificate,

            SignatureImage: this.getImage(),
            SignatureCertificate: this.getSignatureCertificate(),
            IsKeyEncrypted: this.isKeyEncrypted
        };
    }

    getImage () {
        if (this.signatureImage) {
            var image = Utils.file.image.getBase64(this.signatureImage);

            return {
                FileName: `signature_img.${image.extension}`,
                Base64File: image.data,
            };
        }
    }

    getSignatureCertificate () {
        if (this.signatureCertificateBase64) {
            return {
                FileName: this.signatureCertificateFileName,
                Base64File: this.signatureCertificateBase64,
            };
        }
    }
}
